import { ENTITY_LABELS } from "./labelMapping";

function t(language, { en, it, ja }) {
  if (language === "it") return it;
  if (language === "ja") return ja;
  return en;
}

export function transformActionsData(data) {
  if (!data || data.length == 0) return;
  const transformedData = [];

  // Group data by parentKey
  const groupedData =
    data?.reduce((acc, item) => {
      if (!acc[item.parentKey]) {
        acc[item.parentKey] = [];
      }
      acc[item.parentKey].push(item);
      return acc;
    }, {}) || {};

  // Transform grouped data
  Object.entries(groupedData)?.forEach(([parentKey, items]) => {
    const compTitles =
      items?.filter((key) => !key?.isSelf)?.map((item) => item?.title) || [];

    transformedData.push({
      parentKey,
      score: items?.[0]?.score,
      sources: items?.[0]?.sources,
      rationale: items?.[0]?.rationale,
      compTitles,
      mainTitle: `The ${parentKey} score is ${items?.[0]?.score} in this category.`,
    });
  });

  return transformedData;
}

export const transformSourceActionsData = (dataArray) => {
  if (!dataArray || dataArray.length === 0) return [];
  const sourcesMap = {};

  dataArray?.forEach((data) => {
    data?.sources?.forEach(({ domain_url, fullUrl }) => {
      if (!sourcesMap[domain_url]) {
        sourcesMap[domain_url] = {
          domain: domain_url,
          fullUrls: new Set(),
          groupedActions: {},
        };
      }
      fullUrl?.forEach((url) => sourcesMap[domain_url].fullUrls.add(url));

      const category = `${data.brand} | ${data.llm} | ${data.persona} | ${data.market} | ${data.geography}`;

      if (!sourcesMap[domain_url].groupedActions[category]) {
        sourcesMap[domain_url].groupedActions[category] = new Set();
      }

      sourcesMap[domain_url].groupedActions[category].add(
        data.title || data.mainTitle
      );
      data?.compTitles?.forEach((title) =>
        sourcesMap[domain_url].groupedActions[category].add(title)
      );
    });
  });

  return Object.values(sourcesMap)?.map((entry) => ({
    source: entry.domain,
    fullUrls: [...entry.fullUrls],
    groupedActions: Object.entries(entry.groupedActions).map(
      ([category, actions]) => ({
        category,
        actions: [...actions],
      })
    ),
  }));
};

export async function prepareActionsListData(
  data,
  getSourcesWithAlias,
  sourceAliasIds,
  createDomainUrlMapping
) {
  if (!data || data.length === 0) return [];
  let result = [];
  let uniqueSources = new Set();

  // Collect unique sources from all items before iteration
  data.forEach((item) => {
    Object.values(item).forEach((categoryArray) => {
      if (Array.isArray(categoryArray)) {
        categoryArray.forEach((entry) => {
          if (entry.sources) {
            entry.sources.forEach((source) => uniqueSources.add(source));
          }
        });
      }
    });
  });

  let sourceFullUrls = [];
  if (uniqueSources.size > 0) {
    sourceFullUrls = await getSourcesWithAlias({
      sources: Array.from(uniqueSources),
      sourceAliasIds: sourceAliasIds?.flat(),
    });
  }
  const domainUrlMapping = createDomainUrlMapping(sourceFullUrls?.data);

  data.forEach((item) => {
    const { market, geography, category, persona, brand, llm, ...categories } =
      item;

    Object.keys(categories).forEach((categoryKey) => {
      if (Array.isArray(categories[categoryKey])) {
        categories[categoryKey].forEach((entry) => {
          let actionJson = {
            parentKey: categoryKey,
            score: entry.score || "0",
            sources:
              entry?.sources?.map((url) => ({
                domain_url: url,
                fullUrl: domainUrlMapping?.[url] || [],
              })) || [],
            rationale: entry.rationale || false,
            compTitles: entry.compTitles || [],
            mainTitle: entry.mainTitle || "",
            brand,
            persona,
            geography,
            market,
            llm,
            category,
            isProduct: item?.isProduct,
          };

          result.push(actionJson);
        });
      }
    });
  });

  return result;
}

export function generateCombinations(data1, data2) {
  const { brand = [], product = [] } = data2;
  const newEntries = [];

  // Helper function to safely check duplicates
  const exists = (entry) =>
    data1.some(
      (e) =>
        e.market === entry.market &&
        e.geography === entry.geography &&
        e.persona === entry.persona &&
        e.category === entry.category &&
        e.brand === entry.brand &&
        e.llm === entry.llm
    );

  // ✅ Process brand records
  brand.forEach((item) => {
    const entry = {
      market: item.marketname,
      geography: item.geographyname,
      persona: item.personaname,
      category: item.categoryname,
      brand: item.brandname,
      llm: item.llmname,
    };

    if (!exists(entry)) newEntries.push(entry);
  });

  // ✅ Process product records (add is_product: true)
  product.forEach((item) => {
    const entry = {
      market: item.marketname,
      geography: item.geographyname,
      persona: item.personaname,
      category: item.categoryname,
      brand: item.productname,
      llm: item.llmname,
      is_product: true,
    };

    if (!exists(entry)) newEntries.push(entry);
  });

  return [...data1, ...newEntries];
}


// export function generateCombinations(data1, data2) {
//   const {
//     llm = [],
//     geo = [],
//     market = [],
//     brands = [],
//     products = [],
//     brandPersonas = [],
//     productPersonas = [],
//     brandCategories = [],
//     productCategories = [],
//   } = data2;
//   let newEntries = [];

//   const generateEntries = (items, personas, categories, type) => {
//     items.forEach((item) => {
//       personas.forEach((persona) => {
//         llm.forEach((llmItem) => {
//           market.forEach((marketItem) => {
//             geo.forEach((geoItem) => {
//               categories?.forEach((catItem) => {
//                 if (
//                   !data1.some(
//                     (entry) =>
//                       entry.market === marketItem &&
//                       entry.geography === geoItem &&
//                       entry.persona === persona &&
//                       entry.category === catItem &&
//                       entry.brand === item &&
//                       entry.llm === llmItem
//                   )
//                 ) {
//                   newEntries.push({
//                     market: marketItem,
//                     geography: geoItem,
//                     persona: persona,
//                     category: catItem,
//                     brand: item,
//                     llm: llmItem,
//                     isProduct: type === "product",
//                   });
//                 }
//               });
//             });
//           });
//         });
//       });
//     });
//   };

//   // Generate brand-specific combinations
//   generateEntries(brands, brandPersonas, brandCategories, "brand");
//   // Generate product-specific combinations
//   generateEntries(products, productPersonas, productCategories, "product");

//   return [...data1, ...newEntries];
// }

export const reachAndSentimentActions = (data, language = "en", customerId) => {
  if (!Array.isArray(data) || data.length === 0) return [];

  const mainBrand = data?.[0];
  const competitors = data.slice(1);

  const actions = [];

  // === REACH LOGIC ===
  const mainRank = mainBrand?.rank ?? 0;
  const maxRankComp = competitors.reduce(
    (max, curr) => ((curr?.rank ?? 0) > (max?.rank ?? 0) ? curr : max),
    { rank: 0 }
  );
  const rankDiff = (maxRankComp?.rank ?? 0) - mainRank;

  const reachSources = (mainBrand?.extras?.sources || [])
    .flat()
    .filter((str) => typeof str === "string")
    .slice(0, 5);

  const shouldAddReach = mainRank < 10 || rankDiff >= 10;
  let compReachTitle;
  if (rankDiff >= 10) {
    compReachTitle = t(language, {
      en: `The competitor brand ${maxRankComp?.name} achieves the highest ${ENTITY_LABELS.rank} score of ${maxRankComp?.rank} in this case.`,
      it: `In questo caso, il marchio concorrente ${maxRankComp?.name} ottiene il punteggio di visibilità più alto, ovvero ${maxRankComp?.rank}.`,
      ja: `このケースでは、競合ブランド${maxRankComp?.name}が最高の${ENTITY_LABELS.rank}スコア${maxRankComp?.rank}を達成しています。`,
    });
  } else {
    compReachTitle = "";
  }

  if (shouldAddReach) {
    actions.push({
      number: 1,
      title: "reach",
      descriptions: [
        {
          text: t(language, {
            en: `The ${ENTITY_LABELS.rank} score stands at ${mainRank} in this case.`,
            it: `In questo caso il punteggio di visibilità è ${mainRank}.`,
            ja: `このケースでは、${ENTITY_LABELS.rank}スコアは${mainRank}です。`,
          }),
          rationale: "",
          compTitles: [compReachTitle],
          additionalInfo: reachSources,
        },
      ],
    });
  }

  // === SENTIMENT LOGIC ===
  const mainFav = mainBrand?.favorability ?? 0;
  const maxFavComp = competitors.reduce(
    (max, curr) =>
      (curr?.favorability ?? 0) > (max?.favorability ?? 0) ? curr : max,
    { favorability: 0 }
  );
  const favDiff = (maxFavComp?.favorability ?? 0) - mainFav;

  const sentimentSources = (mainBrand?.extras?.sentimentMeta || [])
    .flat() // flatten outer array
    .flatMap((obj) => obj?.sources || [])
    .filter((str) => typeof str === "string")
    .slice(0, 5);

  const favThreshold = customerId === 60 ? 25 : 10;
  const shouldAddSentiment = mainFav < favThreshold || favDiff >= 5;

  let compTitle;
  if (favDiff >= 5) {
    compTitle = t(language, {
      en: `The competitor brand ${maxFavComp?.name} achieves the highest sentiment score of ${maxFavComp?.favorability} in this case.`,
      it: `In questo caso, il marchio concorrente ${maxFavComp?.name} ottiene il punteggio di sentiment più alto, ovvero ${maxFavComp?.favorability}.`,
      ja: `このケースでは、競合ブランド${maxFavComp?.name}が最高のセンチメントスコア${maxFavComp?.favorability}を達成しています。`,
    });
  } else {
    compTitle = "";
  }

  if (shouldAddSentiment) {
    actions.push({
      number: 1,
      title: "sentiment",
      descriptions: [
        {
          text: t(language, {
            en: `The Sentiment score stands at ${mainFav} in this case.`,
            it: `In questo caso il punteggio Sentiment è ${mainFav}.`,
            ja: `このケースでは、センチメントスコアは${mainFav}です。`,
          }),
          rationale: "",
          compTitles: [compTitle],
          additionalInfo: sentimentSources,
        },
      ],
    });
  }

  return actions;
};

export function extractFocusAreas(data, type, language = "en") {
  if (!data || data.length === 0) return;

  const configMap = {
    [ENTITY_LABELS.brandPillar]: {
      fieldKey: "scores",
      scoreKey: "score",
      explanationPath: ["explanation"],
      sourcesPath: ["sources"],
      titlePrefix: ENTITY_LABELS.brandPillar,
    },
    [ENTITY_LABELS.purchaseCriteria]: {
      fieldKey: "brands",
      scoreKey: "rating",
      explanationPath: ["explanation"],
      sourcesPath: ["sources"],
      titlePrefix: ENTITY_LABELS.purchaseCriteria,
    },
    [ENTITY_LABELS.productDimension]: {
      fieldKey: "products",
      scoreKey: "score",
      explanationPath: ["subcategories", "0", "explanation"],
      sourcesPath: ["subcategories", "0", "sources"],
      titlePrefix: ENTITY_LABELS.productDimension,
    },
  };

  const config = configMap[type];
  if (!config) return;

  const { fieldKey, scoreKey, explanationPath, sourcesPath, titlePrefix } =
    config;

  const descriptions = [];

  const getPath = (obj, pathArr) =>
    pathArr.reduce((acc, key) => {
      const parsedKey = isNaN(Number(key)) ? key : Number(key);
      return acc && acc[parsedKey] !== undefined ? acc[parsedKey] : "";
    }, obj);

  data.forEach((attr) => {
    const { name: attribute } = attr;
    const fieldValues = attr[fieldKey];
    if (!fieldValues || fieldValues.length === 0) return;

    const mainBrand = fieldValues[0];
    const compScores = fieldValues.slice(1);

    const maxComp = compScores.reduce(
      (max, item) => (item[scoreKey] > max[scoreKey] ? item : max),
      { [scoreKey]: -Infinity }
    );

    const shouldInclude =
      mainBrand[scoreKey] <= 4 || maxComp[scoreKey] - mainBrand[scoreKey] >= 2;


    let compTitle;
    if (maxComp[scoreKey] - mainBrand[scoreKey] >= 2) {
      compTitle = t(language, {
        en: `The competitor brand ${maxComp?.name} achieves the highest score of ${maxComp?.[scoreKey]} in this case.`,
        it: `In questo caso, il marchio concorrente ${maxComp?.name} ottiene il punteggio più alto di ${maxComp?.[scoreKey]}.`,
        ja: `このケースでは、競合ブランド${maxComp?.name}が最高スコア${maxComp?.[scoreKey]}を達成しています。`,
      });
    } else {
      compTitle = "";
    }

    if (shouldInclude) {
      descriptions.push({
        text: t(language, {
          en: `The ${titlePrefix}-${attribute} score stands at ${mainBrand?.[scoreKey]} in this case.`,
          it: `In questo caso, il punteggio ${titlePrefix}-${attribute} è ${mainBrand?.[scoreKey]}.`,
          ja: `このケースでは、${titlePrefix}-${attribute}スコアは${mainBrand?.[scoreKey]}です。`,
        }),
        rationale: getPath(mainBrand, explanationPath) || "",
        additionalInfo: getPath(mainBrand, sourcesPath) || [],
        compTitles: [compTitle],
      });
    }
  });

  if (descriptions.length) {
    return {
      number: descriptions.length,
      title: type,
      descriptions,
    };
  }
}

export function handlePerformanceData(data) {
  const combinedPerformance = data
    .filter(
      (item) =>
        item.title === ENTITY_LABELS.purchaseCriteria ||
        item.title === ENTITY_LABELS.brandPillar ||
        item.title === ENTITY_LABELS.productDimension
    )
    .reduce(
      (acc, curr) => {
        acc.title = "risk";
        acc.number += curr.number;
        acc.descriptions.push(...curr.descriptions);
        return acc;
      },
      { title: "", number: 0, descriptions: [] }
    );

  // const textSet = new Set();
  // combinedPerformance.descriptions = combinedPerformance.descriptions.filter(
  //   (desc) => {
  //     const value =
  //       typeof desc.text === "string" ? desc.text.trim().toLowerCase() : null;
  //     if (!value || textSet.has(value)) return false;
  //     textSet.add(value);
  //     return true;
  //   }
  // );

  // combinedPerformance.number = combinedPerformance.descriptions.length;

  const modifiedData = [
    ...data.filter(
      (item) =>
        item.title !== ENTITY_LABELS.purchaseCriteria &&
        item.title !== ENTITY_LABELS.brandPillar &&
        item.title !== ENTITY_LABELS.productDimension
    ),
    combinedPerformance,
  ];

  return modifiedData;
}

export function filterData(data1, data2) {
  const brandAssociations = {};
  const productAssociations = {};

  // Build associations map
  data2.brands.forEach((brand) => {
    brandAssociations[brand.brand_name] = {
      geos: new Set(brand.geos),
      personas: new Set(brand.personas),
      category: new Set(brand.category),
      llms: new Set(brand.llms),
      markets: new Set(brand.markets),
    };
  });

  if (data2.products && data2.products.length > 0) {
    data2.products.forEach((product) => {
      productAssociations[product.product_name] = {
        geos: new Set(product.geos),
        personas: new Set(product.personas),
        category: new Set(product.category),
        llms: new Set(product.llms),
        markets: new Set(product.markets),
      };
    });
  }

  const filtered = data1.filter((entry) => {
    const {
      brand,
      geography,
      persona,
      category,
      llm,
      market,
      isProduct = false,
    } = entry;

    const associations = isProduct
      ? productAssociations[brand]
      : brandAssociations[brand];

    if (!associations) return false;

    return (
      associations.geos.has(geography) &&
      associations.personas.has(persona) &&
      associations.category.has(category) &&
      associations.llms.has(llm) &&
      associations.markets.has(market)
    );
  });

  return filtered;
}


/*in Brand audit we need to generate focus Area for llm ,market ,category  wise so for this filter we pass those data to our function*/
export function callingForExtFocusAreasForBrandAudit({
  categoryDimension,
  coreAttributes,
  brandScore,
  taxonomy,
  competitors,
  customerId,
}) {
  const actionsObj = { Reach: [], Sentiment: [], Performance: [] }; // initial structure
  const nonActionsObj = { visibility: [], sentiment: [], brand_pillars: [], purchase_criteria: [], product_taxonomy: [] }; // initial structure

  function formatName(str) {
    return str
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  }

  function roundNumber(num) {
    return num % 1 < 0.5 ? Math.floor(num) : Math.ceil(num);
  }

  /*visibility*/
  // Validate brandScore before processing
  const isValid =
    Array.isArray(brandScore) &&
    brandScore.length === competitors.length + 1 &&
    brandScore.every(
      (obj) =>
        obj &&
        typeof obj === "object" &&
        typeof obj.total === "number" &&
        obj.total > 0
    );

  if (isValid) {
    const brandScoreData = brandScore.map((item) => ({
      extras: item.extras,
      favorability: item.favorability,
      name: item.name,
      rank: item.rank,
      total: item.total,
    }));

    const { actions, nonActions } =
      reachAndSentimentActionsForBrandAudit(brandScoreData, customerId) ?? [];
    /*reach and sentiment action data*/
    actionsObj.Sentiment = actions?.Sentiment?.length
      ? actions.Sentiment
      : actionsObj.Sentiment;
    actionsObj.Reach = actions?.Reach?.length
      ? actions.Reach
      : actionsObj.Reach;

    /*Reach and seniment nonActions*/
    nonActionsObj.sentiment = nonActions?.sentiment?.length
      ? nonActions.sentiment
      : nonActionsObj.sentiment;
    nonActionsObj.visibility = nonActions?.visibility?.length
      ? nonActions.visibility
      : nonActionsObj.visibility;
  }

  /*performance*/
  if (categoryDimension?.data && categoryDimension?.data.length > 0) {
    const { actions, nonActions } = extractFocusAreasForBrandAudit(
      categoryDimension?.data,
      ENTITY_LABELS.purchaseCriteria
    );
    if (actions.length) {
      actionsObj.Performance.push(...actions);
    } else {
      nonActionsObj.purchase_criteria.push(...nonActions)
    }


  }

  /*performance*/
  if (
    coreAttributes &&
    coreAttributes.category_averages &&
    Object.keys(coreAttributes.category_averages).length !== 0
  ) {
    const coreAttributesData = Object.keys(
      coreAttributes.category_averages
    ).map((item) => {
      const scores = coreAttributes.products.map((p) => ({
        name: p.brandName || p.name,
        score: p.attributes[item]?.score,
        explanation: p.attributes[item]?.explanation,
        sources: p.attributes[item]?.sources,
      }));
      return {
        name: formatName(item),
        scores,
      };
    });

    if (coreAttributesData && coreAttributesData.length > 0) {
      const { actions, nonActions } = extractFocusAreasForBrandAudit(
        coreAttributesData,
        ENTITY_LABELS.brandPillar
      );

      if (actions.length) {
        actionsObj.Performance.push(...actions);
      }
      if (nonActions.length) {
        nonActionsObj.brand_pillars.push(...nonActions);
      }
    }
  }

  if (taxonomy && taxonomy?.categories && taxonomy?.categories.length !== 0) {
    let categories = taxonomy?.categories?.map((category) => ({
      name: category.name,
      products: taxonomy?.products?.map((product) => {
        const subcategories = Object.values(
          product.scores[category.name]?.subcategories || {}
        );
        const totalScore = subcategories.length
          ? subcategories.reduce(
            (acc, item) => acc + (isNaN(+item.score) ? 0 : +item.score),
            0
          )
          : 0;
        const average = subcategories.length
          ? totalScore / subcategories.length
          : 0;

        return {
          name: product.name,
          score: roundNumber(average),
          subcategories:
            Object.keys(
              product.scores[category.name]?.subcategories || {}
            )?.map((subcat) => ({
              name: subcat,
              sources:
                product.scores[category.name]?.subcategories?.[subcat].sources,
              score:
                product.scores[category.name]?.subcategories?.[subcat].score,
              explanation:
                product.scores[category.name]?.subcategories?.[subcat]
                  .explanation,
            })) || [],
        };
      }),
    }));

    const headerOrder = competitors.map((h) => h.name);
    categories = categories.map((category) => ({
      ...category,
      products: category.products.sort(
        (a, b) => headerOrder.indexOf(a.name) - headerOrder.indexOf(b.name)
      ),
    }));

    if (categories?.length > 0) {
      const { actions, nonActions } = extractFocusAreasForBrandAudit(
        categories,
        ENTITY_LABELS.productDimension
      );
      if (actions.length) {
        actionsObj.Performance.push(...actions);
      }
      if (nonActions.length) {
        nonActionsObj.brand_pillars.push(...nonActions);
      }
    }
  }

  return { actionsObj, nonActionsObj };
}


/*performance*/
/*when formating perfomance data according to new UI for Focus Area(Table ui)  in brand Audit use this function*/
export function extractFocusAreasForBrandAudit(data, type) {
  if (!data || data.length === 0) return;

  const configMap = {
    [ENTITY_LABELS.brandPillar]: {
      fieldKey: "scores",
      scoreKey: "score",
      explanationPath: ["explanation"],
      sourcesPath: ["sources"],
      titlePrefix: ENTITY_LABELS.brandPillar,
    },
    [ENTITY_LABELS.purchaseCriteria]: {
      fieldKey: "brands",
      scoreKey: "rating",
      explanationPath: ["explanation"],
      sourcesPath: ["sources"],
      titlePrefix: ENTITY_LABELS.purchaseCriteria,
    },
    [ENTITY_LABELS.productDimension]: {
      fieldKey: "products",
      scoreKey: "score",
      explanationPath: ["subcategories", "0", "explanation"],
      sourcesPath: ["subcategories", "0", "sources"],
      titlePrefix: ENTITY_LABELS.productDimension,
    },
  };

  const config = configMap[type];
  if (!config) return;

  const { fieldKey, scoreKey, explanationPath, sourcesPath, titlePrefix } =
    config;

  const actions = [];
  const nonActions = [];

  const getPath = (obj, pathArr) =>
    pathArr.reduce((acc, key) => {
      const parsedKey = isNaN(Number(key)) ? key : Number(key);
      return acc && acc[parsedKey] !== undefined ? acc[parsedKey] : "";
    }, obj);

  data.forEach((attr) => {
    const { name: attribute } = attr;
    const fieldValues = attr[fieldKey];
    if (!fieldValues || fieldValues.length === 0) return;

    const mainBrand = fieldValues[0];
    const compScores = fieldValues.slice(1);

    const maxComp = compScores.reduce(
      (max, item) => (item[scoreKey] > max[scoreKey] ? item : max),
      { [scoreKey]: -Infinity }
    );

    const shouldInclude =
      mainBrand[scoreKey] <= 4 || maxComp[scoreKey] - mainBrand[scoreKey] >= 2;
    const compTitle =
      maxComp[scoreKey] - mainBrand[scoreKey] >= 2
        ? `The competitor brand ${maxComp?.name} achieves the highest score of ${maxComp?.[scoreKey]} in this case.`
        : "";

    if (shouldInclude) {
      let sources = fieldValues.reduce((a, b) => {
        a.push(...(b?.sources ?? []));
        return a;
      }, []);

      let sourcesArr = [...new Set(sources)];

      actions.push({
        mainTitle: `The ${titlePrefix}-${attribute} score stands at ${mainBrand?.[scoreKey]} in this case.`,
        rationale: getPath(mainBrand, explanationPath) || "",
        additionalInfo: getPath(mainBrand, sourcesPath) || [],
        compTitles: [compTitle],
        score: mainBrand?.[scoreKey],
        sources: sourcesArr,
      });
    } else {
      nonActions.push(
        `The ${titlePrefix}-${attribute} score stands at ${mainBrand?.[scoreKey]} in this case.`
      );
    }
  });

  return { actions, nonActions };
}

/*Reach and sentiment*/
/*when formating reach & sentiment data according to new UI for Focus Area(Table ui)  in brand Audit use this function*/
export const reachAndSentimentActionsForBrandAudit = (data, customerId) => {
  if (!Array.isArray(data) || data.length === 0) return [];

  const mainBrand = data?.[0];
  const competitors = data.slice(1);

  /*Data we need to show as condition is match or it is action data which need to show in on click on 
   icon red*/
  const actions = { Sentiment: [], Reach: [] };

  /*Non action Data which we show on click on blue icon */
  const nonActions = { sentiment: [], visibility: [] };

  // === REACH LOGIC ===
  const mainRank = mainBrand?.rank ?? 0;
  const maxRankComp = competitors.reduce(
    (max, curr) => ((curr?.rank ?? 0) > (max?.rank ?? 0) ? curr : max),
    { rank: 0 }
  );
  const rankDiff = (maxRankComp?.rank ?? 0) - mainRank;

  const reachSources = (mainBrand?.extras?.sources || [])
    .flat()
    .filter((str) => typeof str === "string")
    .slice(0, 5);

  const shouldAddReach = mainRank < 10 || rankDiff >= 10;
  const compReachTitle =
    rankDiff >= 10
      ? `The competitor brand ${maxRankComp?.name} achieves the highest ${ENTITY_LABELS.rank} score of ${maxRankComp?.rank} in this case.`
      : "";

  if (shouldAddReach) {
    actions.Reach.push({
      parentKey: "Reach",
      mainTitle: `The ${ENTITY_LABELS.rank} score stands at ${mainRank} in this case.`,
      compTitles: [compReachTitle],
      score: mainRank,
      rationale: "",
      sources: reachSources,
    });
  } else {
    nonActions.visibility.push(
      `The ${ENTITY_LABELS.rank} score stands at ${mainRank} in this case.`
    );
  }

  // === SENTIMENT LOGIC ===
  const mainFav = mainBrand?.favorability ?? 0;
  const maxFavComp = competitors.reduce(
    (max, curr) =>
      (curr?.favorability ?? 0) > (max?.favorability ?? 0) ? curr : max,
    { favorability: 0 }
  );
  const favDiff = (maxFavComp?.favorability ?? 0) - mainFav;

  const sentimentSources = (mainBrand?.extras?.sentimentMeta || [])
    .flat() // flatten outer array
    .flatMap((obj) => obj?.sources || [])
    .filter((str) => typeof str === "string")
    .slice(0, 5);

  const favThreshold = customerId === 60 ? 25 : 10;
  const shouldAddSentiment = mainFav < favThreshold || favDiff >= 5;
  const compTitle =
    favDiff >= 5
      ? `The competitor brand ${maxFavComp?.name} achieves the highest sentiment score of ${maxFavComp?.favorability} in this case.`
      : "";

  if (shouldAddSentiment) {
    actions.Sentiment.push({
      parentKey: "Sentiment",
      text: `The Sentiment score stands at ${mainFav} in this case.`,
      compTitles: [compTitle],
      score: mainFav,
      rationale: "",
      sources: sentimentSources,
    });
  } else {
    nonActions.sentiment.push(
      `The Sentiment score stands at ${mainFav} in this case.`
    );
  }

  return { actions, nonActions };
};



